/** Unique assigned assembly guids — template tables only show used assemblies. */
export const usedAssemblyGuidsForTemplateTables = (assignments: AssemblyAssignment[]): string[] =>
  Array.from(new Set(assignments.map(assignment => assignment.assembly_guid))).sort()
